<template lang="html">
  <div class="slide">
    <svg class="canvas" ref="scene" viewBox="0 0 4175 3006">
      <rect id="Frame" x="0" y="0" width="4175" height="3006" />
      <clipPath id="clip-frame">
        <use xlink:href="#Frame"/>
      </clipPath>
      <g clip-path="url(#clip-frame)">
        <g transform="scale(1.1) translate(0 -300)">
          <ImageLazy
            width="4175" height="3006"
            :srcs="[
              `${publicPath}scenes/expedition-b/main-b-q80-w1000.jpg`,
              `${publicPath}scenes/expedition-b/main-b.jpg`
            ]" />
        </g>
      </g>
    </svg>
    <SceneDialogue
      ref="d1"
      :width="0.33"
      :tx="0" :ty="0.25">
      Max wanted to share his knowledge of the land with Ansel’s men. He chose to take them to many different sites around the area.
    </SceneDialogue>
    <SceneAudio ref="scene-audio" :src="`${publicPath}scenes/expedition-b/audio-charlie-navajo.mp3`" />
  </div>
</template>

<script>
import Template from "./Template.vue"
import SceneDialogue from "../SceneDialogue"
import {TimelineLite, TweenLite} from "gsap"

export default {
  extends: Template,
  mounted() {
    const d1 = this.$refs["d1"].$el
    const scene = this.$refs["scene"]
    TweenLite.set(scene, {opacity: 0})
    TweenLite.set(d1, {opacity: 0})

    // this.tl = new TimelineLite({paused: true})
    this.tl.add(TweenLite.to(scene, 1, {opacity: 1}))
    this.tl.add(TweenLite.to(d1, 1, {opacity: 1}))
  },
  methods: {
    enter() {this.tl.play()}
  },
  components: {
    SceneDialogue,
  }
}
</script>

<style lang="css" scoped>
</style>
